import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { resourceTypes } from '@shared/constants/resourceTypes';
import { IStatsAndResources } from '@shared/interfaces/resources/stats-and-resources';
import { ApiService } from '@shared/services/api.service';
import { UserPublisherService } from '@shared/services/publishers/user-publisher.service';
import dayjs from 'dayjs';
import { Subscription } from 'rxjs';
import { AddMoreResourcesCardComponent } from '../add-more-resources-card/add-more-resources-card.component';
import { PERMISSIONS } from '@access/permissions';
import { AccessService } from '@access/access.service';

@Component({
  selector: 'app-stats-and-resources',
  templateUrl: './stats-and-resources.component.html',
  styleUrls: ['./stats-and-resources.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatsAndResourcesComponent implements OnInit, OnDestroy {
  @ViewChild('userResources') userResources?: AddMoreResourcesCardComponent;
  
  resourceTypes = resourceTypes;
  subscriptions = new Subscription();
  
  protected readonly donutSize: number = 55;
  protected readonly today = dayjs().format('L')
  
  protected statsAndResources?: IStatsAndResources;

  constructor(
    private readonly api: ApiService,
    private readonly accessService: AccessService,
    private readonly userPublisherService: UserPublisherService,
    private readonly changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {    
    this.subscriptions.add(
      this.api.getStatsAndAvailableResources()
        .subscribe(res => {
          this.statsAndResources = res;
          this.changeDetector.markForCheck();
        })
    );

    this.subscriptions.add(
      this.userPublisherService.getStatsAndResourcesObservable()
        .subscribe(sar => {
          this.statsAndResources = sar;
          this.changeDetector.markForCheck();
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }

  bulkPrintIsAvailable(): boolean {
    return this.accessService.hasPermission(PERMISSIONS.Printing.Multi);
  }
}
